import styled from 'styled-components';

export const StyledHeader = styled.header`
  padding-top: ${p => p.theme.space[4]}px;
  padding-bottom: ${p => p.theme.space[4]}px;
  box-shadow: 0px 2px 5px black;
`;
